
import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import {SET_LIGHT_DIALOG_SHOW, SET_LIGHT_DIALOG_HIDE} from "../../../const/infoConst"
import { Input,TimePicker,message,Switch } from "antd";
import { meshLog,SPGet } from "../../../utils/spUtils";
import './createSchePage.less';
import dayjs from 'dayjs';
import moment from 'moment';
import scene from "../../../imgs/item/scene.png";
import time from "../../../imgs/item/time.png";
import quest from "../../../imgs/item/quest.png";
import group from "../../../imgs/item/group.png";
import repeat from "../../../imgs/item/repeat.png";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../imgs/btn/arrow_down.png";
import btn_add from "../../../imgs/btn/btn_add.png";
import { getAllGroupsAndDevices } from '../../../utils/meshUtils';
import { transIntTo2Str } from "../../../utils/dataUtils";
import { getWeekQuestDesc, judgeWeekNameExist,saveScheduleInfo } from '../../../utils/scheduleUtils';

let s_name="";
let t_h=10;
let t_m=0;
let s_mId=0;
let s_group=[];
let s_isAdd=false;


export default class CreateSchePage extends Component {   
    constructor(props) {
        super(props);
        this.state = {
            sceneName: '',

            time_info:moment("10:00", "HH:mm"),
            time_text:"10:00",
            time_hide:false,

            quest_info:"ON/OFF: OFF",

            isGroupShow:1,   //0-隐藏  1-展开
            groups:[],

            repeat_switch: false,
            w_mon:0,
            w_tues:0,
            w_weds:0,
            w_thurs:0,
            w_fri:0,
            w_sat:0,
            w_sun:0,


        };
    }

    componentDidMount() {
        this.setState({ groups: getAllGroupsAndDevices() });

        //新增或编辑
        PubSub.subscribe("update_scene_data_ui", (msg, index) => {
            this.showSceneDetailDataUI();
        })
        PubSub.subscribe(SET_LIGHT_DIALOG_HIDE, (msg, index) => {
            this.setState({ 
                quest_info:getWeekQuestDesc(),
            });
        })
    }
    
    //新增或编辑ui
    showSceneDetailDataUI(){
        let sche = JSON.parse(SPGet("edit_schedule"));
        s_name=sche.name;
        t_h=parseInt(sche.time/60);
        t_m=parseInt(sche.time%60);
        s_mId=sche.sceneID;
        s_group=sche.groupIDs;

        let repeat=sche.repeatWeek; //0-日程 0～2应急电源
        let week=sche.repeatMode;
        s_isAdd=sche.isAdd;

        let arr=this.state.groups;
        for (let i = 0; i < arr.length; i++) {
            let add=false;
            for (let j = 0; j < s_group.length; j++) {
                if(arr[i].id==s_group[j]){
                    add=true;
                }
            }
            if(add){
                arr[i].checked=true;
            }else{
                arr[i].checked=false;
            }
        }

        meshLog("新增或编辑定时");
        this.setState({ 
            sceneName:s_name,
            time_info:moment(t_h+":"+transIntTo2Str(t_m), "HH:mm"),
            time_text:t_h+":"+transIntTo2Str(t_m),
            quest_info:getWeekQuestDesc(),
            groups:arr,
            w_mon:(parseInt(week%2)>=1)?1:0,
            w_tues:(parseInt((week%4)/2)>=1)?1:0,
            w_weds:(parseInt((week%8)/4)>=1)?1:0,
            w_thurs:(parseInt((week%16)/8)>=1)?1:0,
            w_fri:(parseInt((week%32)/16)>=1)?1:0,
            w_sat:(parseInt((week%64)/32)>=1)?1:0,
            w_sun:(parseInt((week%128)/64)>=1)?1:0,
            repeat_switch:(parseInt(week/128)>=1)?false:true,
        });

    }

    //改名字
    onNameChange = (e) => {
        meshLog("s_name",e.target.value);
        s_name=e.target.value;
        this.setState({ 
            sceneName:s_name,
        });
    }

    //改时间
    handleTimeChange = (time, timeString) => {
        meshLog("wjk onTimeChange");
        const arr = timeString.split(':');
        t_h=arr[0];
        t_m=arr[1];
        console.log(time, timeString,t_h,t_m);
        this.setState({ 
            // time_info:moment(t_h+":"+transIntTo2Str(t_m), "HH:mm"),
            time_text:t_h+":"+transIntTo2Str(t_m),
        });
    };
    handleOnFocus= () => {
        // meshLog("wjk handleOnFocus");
        this.setState({ 
            time_hide:true,
        });
    }
    handleOnBlur= () => {
        // meshLog("wjk handleOnBlur");
        this.setState({ 
            time_hide:false,
        });
    }

    //light弹窗
    showAddLightDialog(){
        meshLog("AddLightDialog");
        PubSub.publish(SET_LIGHT_DIALOG_SHOW,'')
    }

    //关闭弹窗
    sendDataToParent(){
        this.props.onDataToParent("");
    };

    //保存
    saveDataToParent(){
        const { w_mon,w_tues,w_weds,w_thurs,w_fri,w_sat,w_sun } = this.state;
        if(s_name==""){
            message.warning({content:"Names can't be empty",style:{fontSize:"25px"}});
            return;
        }
        if(s_isAdd && judgeWeekNameExist(s_name)){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            return;
        }
        let time=parseInt(t_h)*60+parseInt(t_m);
        let repeat=(this.state.repeat_switch?0:1);

        saveScheduleInfo(s_name,time,s_group,repeat,w_mon,w_tues,w_weds,w_thurs,w_fri,w_sat,w_sun,s_isAdd,s_mId);

        this.props.onDataToParent("");
    };
    
    //多选框
    handleCheckboxChange= (id) => {
        s_group=[];
        let ss=0;

        let arr=this.state.groups;
        for (let i = 0; i < arr.length; i++) {
            if(arr[i].id==id){
                arr[i].checked=!arr[i].checked;
            }
            if(arr[i].checked){
                s_group[ss]=arr[i].id;
                ss++;
            }
        }
        meshLog('wjk 多选框', id,s_group);
        this.setState({ groups: arr });
    };




    //组展开开关
    groupArrowClick = () => {
        let mm=this.state.isGroupShow;
        this.setState({isGroupShow:mm==1?0:1})
    }

    //repeat开关
    repeatSwitch = (checked) => {
        this.setState({ repeat_switch: checked });
    }

    // 星期选择
    week1BtnClick= () => {
        let mm=(this.state.w_mon==1?0:1);
        meshLog("w_mon",mm);
        this.setState({ w_mon: mm});
    }
    week2BtnClick= () =>{
        let mm=this.state.w_tues==1?0:1;
        this.setState({ w_tues: mm});
    }
    week3BtnClick= () =>{
        let mm=this.state.w_weds==1?0:1;
        this.setState({ w_weds: mm});
    }
    week4BtnClick= () =>{
        let mm=this.state.w_thurs==1?0:1;
        this.setState({ w_thurs: mm});
    }
    week5BtnClick= () =>{
        let mm=this.state.w_fri==1?0:1;
        this.setState({ w_fri: mm});
    }
    week6BtnClick= () =>{
        let mm=this.state.w_sat==1?0:1;
        this.setState({ w_sat: mm});
    }
    week7BtnClick= () =>{
        let mm=this.state.w_sun==1?0:1;
        this.setState({ w_sun: mm});
    }


    render() {
        const {sceneName, quest_info, time_info, time_text, time_hide, isGroupShow } = this.state;
        const {repeat_switch, w_mon,w_tues,w_weds,w_thurs,w_fri,w_sat,w_sun } = this.state;
        return (
            <div className="create_schedule_container">
                {/* 1.  标题行 */}
                <div className="sche_row">
                    <div className="row_title">
                        <img src={scene}/>
                        <span>Create Scene</span>
                    </div>
                </div>
                <Input className="scene_name" placeholder="*Scene" value={sceneName} maxLength={15} onChange={this.onNameChange}/>

                {/* 选择时间 */}
                <div className="sche_row">
                    <div className="row_title">
                        <img src={time}/>
                        <span>Select Time</span>
                    </div>
                </div>
                <div className='time_bg'>
                    <span className='time_text'>{time_hide?"":time_text}</span>
                    <TimePicker
                        className='timepicker'
                        defaultValue={dayjs('10:00', 'HH:mm')} format={'HH:mm'}
                        // value={time_info}   
                        needConfirm={true}
                        showNow={false}
                        allowClear={false}
                        inputReadOnly={true}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        onChange={this.handleTimeChange}/>
                </div>
                


                {/* 场景选择 */}
                <div className="sche_row">
                    <div className="row_title">
                        <img src={quest}/>
                        <span>Select Quest</span>
                    </div>
                    <img src={btn_add} onClick={() => { this.showAddLightDialog() }}/>
                </div>

                <div className="section_info">
                    <span>{quest_info}</span>
                </div>

                {/* group选择 */}
                <div className="sche_row">
                    <div className="row_title">
                        <img src={group}/>
                        <span>Associated Group</span>
                    </div>
                    <img src={isGroupShow==0?arrow_right:arrow_down} onClick={() => { this.groupArrowClick() }}/>
                </div>
                {/* group列表 */}
                <div className="groupBg" style={{ display: isGroupShow == 0 ? "none" : "flex" }}>
                    {this.state.groups.map((group) => (
                         <div key={group.id} className="group_item">
                            <span>{group.name}</span>
                            <input className="radioSet" type='checkbox' name='group' value='' checked={group.checked} onChange={() => this.handleCheckboxChange(group.id)}/>   
                        </div>
                    ))}
                </div>        
                {/* repeat选择 */}
                <div className="sche_row">
                    <div className="row_title">
                        <img src={repeat}/>
                        <span>Repeat</span>
                    </div>
                    <Switch defaultChecked={false} checked={repeat_switch} onChange={this.repeatSwitch} />
                </div>

                {/* 星期 */}
                <div className='weekSelect' style={{display:repeat_switch?"flex":"none"}}>
                    <div className='weekBtn1' style={{background:w_mon==1?"#fbc800":"#fff"}} onClick={() => { this.week1BtnClick() }}><span>Mon</span></div>
                    <div className='weekBtn2' style={{background:w_tues==1?"#fbc800":"#fff"}} onClick={() => { this.week2BtnClick() }}><span>Tues</span></div>
                    <div className='weekBtn3' style={{background:w_weds==1?"#fbc800":"#fff"}} onClick={() => { this.week3BtnClick() }}><span>Weds</span></div>
                    <div className='weekBtn4' style={{background:w_thurs==1?"#fbc800":"#fff"}} onClick={() => { this.week4BtnClick() }}><span>Thurs</span></div>
                    <div className='weekBtn5' style={{background:w_fri==1?"#fbc800":"#fff"}} onClick={() => { this.week5BtnClick() }}><span>Fri</span></div>
                    <div className='weekBtn6' style={{background:w_sat==1?"#fbc800":"#fff"}} onClick={() => { this.week6BtnClick() }}><span>Sat</span></div>
                    <div className='weekBtn7' style={{background:w_sun==1?"#fbc800":"#fff"}} onClick={() => { this.week7BtnClick() }}><span>Sun</span></div>
                </div>


                {/* 底部按钮 */}
                <div className="schedule_footer">
                    <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                    <button className='okBtn' onClick={this.saveDataToParent.bind(this)}>Confirm</button>
                </div>

            </div>
            
        );
    }
}
